// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vgdBo82swYZhbP3b7naf\\+Q\\=\\= {\n  width: 370px;\n  margin: 0 auto;\n  padding: 15px 0;\n  border-bottom: 1px solid #ccc;\n}\n", "",{"version":3,"sources":["webpack://src/components/bread_M/index.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;AACF","sourcesContent":[".bread_wrapper{\n  width: 370px;\n  margin: 0 auto;\n  padding: 15px 0;\n  border-bottom: 1px solid #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bread_wrapper": "vgdBo82swYZhbP3b7naf+Q=="
};
export default ___CSS_LOADER_EXPORT___;
